export default __webpack_public_path__ + "static/media/vantagem3.bdfc4e08.png";